import { Signal, WritableSignal } from '@angular/core';

type Entries<T> = {
  [K in keyof T]: [K, T[K]];
}[keyof T][];

// typed Object.entries, use only if you're sure the object won't have excess properties
// read https://stackoverflow.com/a/60142095/7798324
export const objectEntries = <T extends object>(obj: T) => Object.entries(obj) as Entries<T>;
export const objectKeys = <T extends object>(obj: T) => Object.keys(obj) as unknown as (keyof T)[];

type FeatureInput = 'props' | 'methods' | 'stateSignals';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type FeatureCreator<T extends FeatureInput, K = object> = () => (...args: any) => { [key in T]: K };
export type GetProps<T extends FeatureCreator<'props'>> = ReturnType<ReturnType<T>>['props'];
export type GetMethods<T extends FeatureCreator<'methods'>> = ReturnType<ReturnType<T>>['methods'];

// takes a record and makes every signal writable; other values are returned as is
export type MakeWritable<T extends object> = {
  [Key in keyof T]: T[Key] extends Signal<infer U> ? WritableSignal<U> : T[Key];
};
